import useStoreSelector from 'store/useStoreSelector';

function useServerDown() {
	const { serverDown } = useStoreSelector(({ session }) => session);

	return serverDown;
}

export default useServerDown;
